import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

import { AutomationsFlowsGetListResponseDTO } from './dto/automations-flows.getList.response.dto';
import { AutomationsFlowsGetResponseDTO } from './dto/automations-flows.get.response.dto';

export class AutomationsFlowsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/flows`, client.getTimeout());
  }

  async getList(request: { settings?: RetrySettings }): Promise<AutomationsFlowsGetListResponseDTO> {
    return (
      await this.client.get<AutomationsFlowsGetListResponseDTO>(
        `/list`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request.settings,
        },
      )
    ).data;
  }

  async get(request: {
    params: {
      path: string;
    };
    settings?: RetrySettings;
  }): Promise<AutomationsFlowsGetResponseDTO> {
    return (
      await this.client.get<AutomationsFlowsGetResponseDTO>(``, request.params, {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      })
    ).data;
  }
}
